var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable import/export */
import { pipe } from 'fp-ts/function';
import * as RTE from 'fp-ts/ReaderTaskEither';
export * from 'fp-ts/ReaderTaskEither';
export { chainFirstReaderIOK, chainFirstReaderIOKW, chainReaderIOK, chainReaderIOKW, fromReaderIOK, leftReaderIO, rightReaderIO } from 'fp-ts-contrib/ReaderTaskEither';
export var provide = function (r2) {
    return function (r1) {
        return pipe(RTE.Do, RTE.apS('a1', r1), RTE.bindW('a2', function (_a) {
            var a1 = _a.a1;
            return RTE.fromTaskEither(r2(a1));
        }), RTE.map(function (_a) {
            var a1 = _a.a1, a2 = _a.a2;
            return (__assign(__assign({}, a1), a2));
        }));
    };
};
